module.exports = __webpack_public_path__ + "assets/f7cb2a6f48bf9e0744002fa149279fba.json";